import config from "../config/config";

(function (w, d, s) {
  var l = 'IFlyCollector', f = d.getElementsByTagName(s)[0], j = d.createElement(s), w = window;
  w[l] = {};
  let c = w[l];
  c._o = function (a) {
    return function () {
      (c._e = c._e || []).push([a, arguments]);
    }
  };
  let e = ['init', 'onEvent', 'onError', 'bindUser', 'updateCustomConfig'];
  for (let i = 0; i < e.length; i++) {
    c[e[i]] = c._o.call(null, e[i]);
  }
  j.async = true;
  j.src = 'http://ebgjs.changyan.com/jssdk/entry.js';
  f.parentNode.insertBefore(j, f);
})(window, document, 'script');

IFlyCollector.init(
  {
    appId: config.getConfig().mdianConfig.appId,
    host: config.getConfig().mdianConfig.host,//接入SDK的网站的域名
    debug: true,//
    spa: false,
    configUrl: config.getConfig().mdianConfig.configUrl,
    collectUrl: config.getConfig().mdianConfig.collectUrl,
    source: config.getConfig().mdianConfig.source
  });



// WEBPACK FOOTER //
// ./src/api/md.js